import submitCommand from '../../../services/submitCommand';
import { Step } from '../../steps/models/course';

export const resendFeedbackUser = (
  courseId: string,
  task: Step,
  email: string,
  firstName: string,
  initiatingUserId: string
) => {
  const cmd = {
    id: courseId,
    taskInstance: task,
    email: email,
    firstName: firstName,
    initiatingUserId: initiatingUserId,
  };

  return submitCommand(
    courseId,
    cmd,
    'ReSendFeedbackEmailToObserver',
    'FeedbackEmailToObserverReSent',
    'TaskListInstanceError'
  );
};
